import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { Button } from '../components/Button';
interface LandingPageProps {
  onLoginClick: () => void;
}
export function LandingPage({
  onLoginClick
}: LandingPageProps) {
  return <div className="min-h-screen w-full bg-gradient-to-br from-stone-50 via-teal-50/30 to-stone-50 flex items-center justify-center" data-id="element-915" data-mp="221yzc6le3hfq">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center" data-id="element-916" data-mp="2b018xaj6viem">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="flex items-center justify-center gap-3 mb-12" data-id="element-917" data-mp="2fznohqmhpaql">
          <div className="p-4 bg-teal-600 rounded-2xl" data-id="element-918" data-mp="2zk8b7d8bkhp1">
            <ZapIcon className="w-12 h-12 text-white" data-id="element-919" data-mp="33kij4vfo9i6j" />
          </div>
          <h1 className="text-5xl font-bold text-stone-900" data-id="element-920" data-mp="33ifsc96p3l0r">EL Opgaver</h1>
        </motion.div>

        {/* Login Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} data-id="element-921" data-mp="3dabrzoofjj73">
          <Button onClick={onLoginClick} variant="primary" className="text-lg px-12 py-4" data-id="element-922" data-mp="3n6omupvpo33f">
            Log ind
          </Button>
        </motion.div>
      </motion.div>
    </div>;
}